<div class="flex flex-col w-full h-full gap-4">
  <app-filters-item label="New" class="block">
    <!-- New homes color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.includeNewHomes"
      ariaLabel="Show new homes"
      class="ml-auto"
      colorClass="has-checked:bg-villages-green-50 outline-white/30"
      darkColorClass="dark:has-checked:bg-villages-green-500 dark:outline-white/30"
    />
  </app-filters-item>

  <app-filters-item label="Preowned" class="block">
    <!-- Preowned homes color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.includePreownedHomes"
      ariaLabel="Show preowned homes"
      class="ml-auto"
      colorClass="has-checked:bg-villages-red-500 outline-white/30"
      darkColorClass="dark:has-checked:bg-villages-red-500 dark:outline-white/30"
    />
  </app-filters-item>

  <app-filters-item label="Homesites" class="block">
    <!-- Homesites color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.includeHomesites"
      ariaLabel="Show homesites"
      class="ml-auto"
      colorClass="has-checked:bg-villages-gold-500 outline-white/30"
      darkColorClass="dark:has-checked:bg-villages-gold-500 dark:outline-white/30"
    />
  </app-filters-item>

  <app-filters-item label="Pending">
    <!-- Pending color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.includePendingSales"
      ariaLabel="Show pending sales"
      class="ml-auto"
      colorClass="has-checked:bg-[#ecdcc2] outline-white/30"
      darkColorClass="dark:has-checked:bg-[#ecdcc2] dark:outline-white/30"
    />
  </app-filters-item>

  <div aria-hidden="true" class="w-full border-t border-gray-200 dark:border-gray-700 my-2"></div>

  <app-filters-item label="Sort By" class="w-full lg:hidden text-nowrap">
    <app-select [(value)]="filteringService.sort" [options]="sortByOptions" class="w-56" />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Series" class="w-full">
    <app-select
      allItemsLabel="All series"
      [options]="seriesOptions()"
      [(value)]="filteringService.series"
      class="w-82"
      multiSelect="true"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  @if (stateService.community() !== 'middleton') {
    <app-filters-item label="Areas" class="w-full">
      <app-select
        allItemsLabel="All areas"
        [options]="areasOptions()"
        [(value)]="filteringService.areas"
        class="w-82"
        multiSelect="true"
      />
    </app-filters-item>

    <div
      aria-hidden="true"
      class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
    ></div>
  }

  <app-filters-item label="Beds" class="w-full">
    <app-select
      allItemsLabel="All beds"
      [options]="bedsOptions()"
      [(value)]="filteringService.beds"
      class="w-82"
      multiSelect="true"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Baths" class="w-full">
    <app-select
      allItemsLabel="All baths"
      [options]="bathsOptions()"
      [(value)]="filteringService.baths"
      class="w-82"
      multiSelect="true"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Garage" class="w-full">
    <app-select
      allItemsLabel="All garages"
      [options]="garageOptions()"
      [(value)]="filteringService.garages"
      class="w-82"
      multiSelect="true"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Homesite" class="w-full">
    <app-select
      allItemsLabel="All homesites"
      [options]="homesiteOptions()"
      [(value)]="filteringService.homesites"
      class="w-82"
      multiSelect="true"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Price" class="w-full">
    <div class="flex flex-row items-center gap-2">
      <app-select
        placeholder="No min"
        [(value)]="filteringService.priceLow"
        [options]="priceLow()"
        class="w-38"
      />
      <span class="w-3 text-center">-</span>
      <app-select
        placeholder="No max"
        [(value)]="filteringService.priceHigh"
        [options]="priceHigh()"
        class="w-37"
      />
    </div>
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Minimum Square Feet" class="w-full">
    <app-select [options]="minSqftOptions()" [(value)]="filteringService.minSqft" class="w-32" />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Pool">
    <!-- Pending color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.pool"
      class="ml-auto"
      colorClass="has-checked:bg-[#ecdcc2] outline-white/30"
      darkColorClass="dark:has-checked:bg-[#ecdcc2] dark:outline-white/30"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>

  <app-filters-item label="Open Homes (Today and Tomorrow)">
    <!-- Pending color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
    <app-toggle
      [(checked)]="filteringService.openHomes"
      class="ml-auto"
      colorClass="has-checked:bg-[#ecdcc2] outline-white/30"
      darkColorClass="dark:has-checked:bg-[#ecdcc2] dark:outline-white/30"
    />
  </app-filters-item>

  <div
    aria-hidden="true"
    class="w-full border-t border-gray-200 dark:border-gray-700 my-2 block md:hidden"
  ></div>
</div>
